<template>
  <div class="app-container">
    <NavTitle :title="title" />
    <!-- 企业详情 -->
    <div class="enterprise-header-box" v-loading="loading">
      <div class="enterprise-header-title">
        <div class="title">{{ enterpriseInfo.enterpriseName }}</div>
        <div class="tag-box">
          <div
            v-for="(v, i) in enterpriseInfo.enterpriseTypeList"
            :key="`type-${i}`"
            :class="[
              'enterprise-tag',
              {
                ypsc: v === '药品生产',
                yppf: v === '药品批发',
                lszb: v === '连锁总部',
                lsmd: v === '连锁门店',
                yljg: v === '医疗机构',
                dtmd: v === '单体门店',
              },
            ]"
          >
            {{ v }}
          </div>
          <div
            v-for="(v, i) in enterpriseInfo.tags"
            :key="`tag-${i}`"
            class="enterprise-tag gs"
            @click="handleTag(v)"
          >
            <span>{{ v.tagText }}</span>
            <i class="el-icon-caret-right" />
          </div>
        </div>
      </div>
      <div class="enterprise-header-city">{{ enterpriseInfo.location }}</div>
      <div class="enterprise-header-address">
        <img
          class="enterprise-header-address-img"
          src="@/assets/enterprise/locationFilled.png"
          alt=""
          @click="handleAddress"
        />
        <span>
          {{ enterpriseInfo.licenseAddress }}
        </span>
      </div>
      <div class="enterprise-header-desc">
        <div class="header-desc">
          <div class="header-desc-title">经营分类：</div>
          <div class="header-desc-value">{{ enterpriseInfo.businessType }}</div>
        </div>
        <div class="header-desc">
          <div class="header-desc-title">风险等级：</div>
          <div class="header-desc-value">{{ enterpriseInfo.riskLevel }}</div>
        </div>
        <div class="header-desc">
          <div class="header-desc-title">药学服务：</div>
          <div
            v-for="(v, i) in enterpriseInfo.pharmacistOnlineState"
            :key="`pharmacist-${i}`"
            class="header-desc-value"
          >
            <span
              :class="[
                'header-desc-value-arr',
                {
                  red: v === '线下药师离岗' || v === '远程审方离线',
                  gray: v === '未注册' || v === '未入驻' || v === '未开通',
                },
              ]"
              >{{ v }}</span
            >
            <span
              v-if="i + 1 < enterpriseInfo.pharmacistOnlineState.length"
              class="header-desc-value-icon"
              >｜</span
            >
          </div>
        </div>
        <div class="header-desc">
          <div class="header-desc-title">工作日营业时间：</div>
          <div class="header-desc-value">{{ enterpriseInfo.workTime }}</div>
        </div>
        <div class="header-desc">
          <div class="header-desc-title">节假日营业时间：</div>
          <div class="header-desc-value">{{ enterpriseInfo.holidayTime }}</div>
        </div>
      </div>
    </div>

    <!-- 表格筛选 -->
    <div class="search-box">
      <div class="search-left">
        <div class="search-item">
          <div class="label">人员姓名</div>
          <div class="value">
            <el-input
              v-model="realName"
              placeholder="请输入内容"
              size="mini"
              @keyup.enter.native="handleSearch"
            />
          </div>
        </div>
        <div class="search-item">
          <div class="label">岗位</div>
          <div class="value">
            <el-select
              v-model="stations"
              multiple
              placeholder="请选择"
              size="mini"
              collapse-tags
              style="width: 100%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" size="mini" @click="handleSearch"
          >查询</el-button
        >
        <el-button plain size="mini" @click="handleReset">重置</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <div class="table-box">
      <div class="table-d" ref="tableDRef">
        <div class="code-table-title">人员信息</div>
        <el-table
          ref="workTableRef"
          :data="workList"
          stripe
          highlight-current-row
          :row-key="'id'"
          :header-cell-style="{
            background: '#F0F3F7',
            color: '#2a354e',
            fontWeight: 400,
          }"
          height="450"
          @current-change="handleRowSelect"
          @sort-change="handleSortChange"
          v-loading="loadingList"
          size="mini"
        >
          <el-table-column
            prop="onlineState"
            label="考勤状态"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                :class="[
                  'table-state',
                  { blue: scope.row.onlineState === '离岗' },
                ]"
              >
                {{ scope.row.onlineState }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="人员姓名"
            width="150"
            :show-overflow-tooltip="true"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.userName }}
              </span>
              <span v-if="scope.row.isEnterpriseAdmin">(管理员)</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sex"
            label="性别"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column prop="userStations" label="岗位" width="200">
            <template slot-scope="scope">
              <span
                v-for="(v, i) in scope.row.userStations"
                :key="i"
                class="table-tag"
              >
                {{ v }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="enterpriseName"
            label="机构名称"
            :show-overflow-tooltip="true"
            width="250"
          />
          <el-table-column
            prop="addedTime"
            label="入驻时间"
            :show-overflow-tooltip="true"
            width="250"
            sortable="custom"
          />
          <el-table-column
            prop="lastLoginTime"
            label="最后登录时间"
            :show-overflow-tooltip="true"
            min-width="250"
            sortable="custom"
          />
        </el-table>
      </div>
      <div class="table-page">
        <div class="table-page-index">当前 {{ paging.index }} 页</div>
        <el-pagination
          :current-page="paging.index"
          :page-size="paging.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <Identification ref="IdentificationRef" />
    <Address ref="AddressRef" :list="enterpriseInfo.locationInfos" />
  </div>
</template>

<script>
import Identification from "./components/identification.vue";
import Address from "./components/address.vue";
import NavTitle from "@/components/NavTitle/index.vue";

export default {
  name: "PageEnterprise",
  components: {
    Identification,
    Address,
    NavTitle,
  },
  data() {
    return {
      title: ["机构档案"],
      enterpriseInfo: {},
      realName: "",
      options: [],
      paging: {
        index: 1,
        size: 100,
      },
      workList: [],
      total: 0,
      stations: [],
      selectedRow: null,
      loading: false,
      loadingList: false,
      orders: {
        userName: false,
        lastLoginTime: null,
        addedTime: null,
      },
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {},
  methods: {
    handleSortChange(value) {
      // 人员姓名
      if (value.prop === "userName") {
        if (!value.order) {
          // 默认
          this.orders.userName = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.orders.userName = true;
          this.orders.lastLoginTime = null;
          this.orders.addedTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.orders.userName = false;
          this.orders.lastLoginTime = null;
          this.orders.addedTime = null;
        }
      }
      // 入驻时间
      if (value.prop === "addedTime") {
        if (!value.order) {
          // 默认
          this.orders.addedTime = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.orders.addedTime = true;
          this.orders.userName = null;
          this.orders.lastLoginTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.orders.addedTime = false;
          this.orders.userName = null;
          this.orders.lastLoginTime = null;
        }
      }
      // 最后登录时间
      if (value.prop === "lastLoginTime") {
        if (!value.order) {
          // 默认
          this.orders.lastLoginTime = null;
        }
        if (value.order === "ascending") {
          // 正序
          this.orders.lastLoginTime = true;
          this.orders.userName = null;
          this.orders.addedTime = null;
        }
        if (value.order === "descending") {
          // 倒序
          this.orders.lastLoginTime = false;
          this.orders.userName = null;
          this.orders.addedTime = null;
        }
      }
      this.paging.index = 1;
      this.fetchList();
    },
    handleRowSelect(currentRow) {
      this.selectedRow = currentRow;
    },
    handleAddress() {
      this.$refs.AddressRef.show();
    },
    handleReset() {
      this.realName = "";
      this.stations = [];
    },
    handleSearch() {
      this.paging.index = 1;
      this.fetchList();
    },
    handleTag(value) {
      this.$refs.IdentificationRef.show(value);
    },
    handleSizeChange(value) {
      this.paging.index = 1;
      this.paging.size = value;
      this.fetchList();
    },
    handleCurrentChange(value) {
      this.paging.index = value;
      this.fetchList();
    },
    async fetchList() {
      this.loadingList = true;
      const resWork = await this.$api.enterprise.GetUserList({
        realName: this.realName,
        stations: this.stations,
        paging: this.paging,
        orders: this.orders,
      });
      this.workList = resWork.data;
      this.paging.index = resWork.extended.paging.index;
      this.total = resWork.extended.paging.total;
      this.loadingList = false;
    },
    async fetchData() {
      this.loading = true;
      this.loadingList = true;
      const res = await this.$api.enterprise.GetEnterpriseInfo();
      this.enterpriseInfo = res.data;
      const resStations = await this.$api.support.GetStations();
      this.options = resStations.data;
      const resWork = await this.$api.enterprise.GetUserList({
        realName: this.realName,
        stations: this.stations,
        paging: this.paging,
        orders: this.orders,
      });
      this.workList = resWork.data;
      this.paging.index = resWork.extended.paging.index;
      this.total = resWork.extended.paging.total;
      this.loading = false;
      this.loadingList = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./page.scss";
</style>
